import React, { useState } from "react";
import graph from "./graph";
import schema from "./schema";
import uiSchema from "./uiSchema";

import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useMutation } from "@apollo/client";
import { isEmptyObject } from "helpers/formatObject";
import { Stack, Button, IconButton } from "@mui/material";
import {
  NewDialog,
  MuiFormBuilder,
  NewDialogTitle,
  NewDialogContent,
  NewDialogActions,
} from "components";

import { PasswordRounded } from "@mui/icons-material";

export default function ChangePassword({
  id,
  refetch,
  title = "تغییر رمز ورود",
}) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const { userToken } = useSelector((state) => state.auth);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const [create, { loading }] = useMutation(graph.create.query);

  const onSubmit = async ({ formData }) => {
    try {
      const { data, errors } = await create({
        context: {
          serviceName: graph.create.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          user_ids: id,
          ...formData,
        },
      });
      if (!errors) {
        refetch();
        onClose();
        setFormData({});
        if (!isEmptyObject(data)) {
          data[graph.create.name]?.messages.map((message) =>
            toast.success(String(message))
          );
        }
      }
    } catch (error) {
      setFormData(formData);
    }
  };

  return (
    <>
      <IconButton
        size="small"
        color="warning"
        onClick={onOpen}
        sx={{ bgcolor: "action.hover" }}
      >
        <PasswordRounded fontSize="small" />
      </IconButton>
      <NewDialog open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={1} rowGap={1} bgcolor="background.paper">
            <MuiFormBuilder
              id="create"
              showSubmit={false}
              liveValidate={false}
              schema={schema()}
              uiSchema={uiSchema()}
              formData={formData}
              onSubmit={onSubmit}
            />
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            fullWidth
            size="large"
            type="submit"
            form="create"
            variant="contained"
            disabled={loading}
          >
            {title}
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
